import './App.css';
import { useEffect, useState } from 'react';
import Cookies from "js-cookie";
import Sidebar from './layouts/Sidebar/Sidebar';
import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import AppContext from './context';

// Services
import { AuthService } from './services/auth';

// Layouts
import Login from './layouts/Login/Login';
import { Alert } from './layouts/Alert/Alert';
import { AlertEntity } from './layouts/Alert/AlertEntity';

// Features
import Home from "./features/home/Home"
import { UserContextEntity } from './entities/UserEntity';
import ChangePass from './layouts/ChangePass/ChangePass';
import MasterUser from './features/master/MasterUser';
import TappingMakanan from './features/tapping_makanan/TappingMakanan';
import MasterKaryawan from './features/master/MasterKaryawan';
import MasterVendor from './features/master/MasterVendor';
import InputQtyPorsi from './features/input_qty_porsi/InputQtyPorsi';
import MasterLokasi from './features/master/MasterLokasi';
import DropOffInput from './features/drop_off/DropOffInput';
import DropOffAccByAdmin from './features/drop_off/DropOffAccByAdmin';
import ReportTappingMakanan from './features/report/ReportTappingMakanan';
import ReportDropOff from './features/report/ReportDropOff';
import TappingAdmin from './features/tapping_makanan/TappingAdmin';
import MasterDepartemen from './features/master/MasterDepartemen';
import ReportActualPorsi from './features/report/ReportActualPorsi';
import GuestServing from './features/guest_serving/GuestServing';
import ReportGuestServing from './features/report/ReportGuestServing';
import ReportErrorLogs from './features/report/ReportErrorLogs';
import ReportLongshift from './features/report/ReportLongShift';

function App() {
  const location = useLocation();

  // States
  const [stateShowSidebar, setStateShowSidebar] = useState<boolean>(false);
  const [stateShowLogin, setStateShowLogin] = useState<boolean>(true);
  const [stateShowChangePass, setStateShowChangePass] = useState<boolean>(false);
  const [stateShowLoading, setStateShowLoading] = useState<boolean>(false);

  const [stateShowAlert, setStateShowAlert] = useState<boolean>(false);
  const [alertEntity, setAlertEntity] = useState<AlertEntity | null>(null);

  //give setVersion if want app can change Version
  const [version] = useState<{ ui: string, server: string }>({ ui: "v0.0", server: "v0.0" });


  // Context Entities
  const contextAccessToken: string = Cookies.get('token') ?? '';
  const [contextUserEntity, setContextUserEntity] = useState<UserContextEntity | null>(null);

  // Context Functions
  const contextShowAlertFunc = (val: AlertEntity) => { setStateShowAlert(true); setAlertEntity(val); }
  const contextShowLoadingFunc = (val: boolean) => { setStateShowLoading(val); }
  const contextMakeHeaderFunc = (val: string) => { return val.replace(/ID/g, "Id").replace(/[_-]|(?<=[a-z])(?=[A-Z])/g, " ").toUpperCase(); }

  // REFRESH USER DATA IF COOKIES STILL EXIST
  useEffect(() => {
    console.log('Try refresh...');
    const refresh = async () => {
      const authService = new AuthService();
      try {
        const refreshUser = await authService.refreshLogin();

        if (refreshUser != null) {
          setContextUserEntity(refreshUser);
          setStateShowLogin(false);
        } else {
          setContextUserEntity(null);
        }
      } catch (error) {
        setContextUserEntity(null);
      }
    }

    refresh();
  }, []);

  return (
    <AppContext.Provider
      value={{
        stateShowLoading,
        contextAccessToken,
        contextUserEntity,
        contextShowAlertFunc,
        contextShowLoadingFunc,
        contextMakeHeaderFunc,
      }}>
      <div className="App">
        <div className="navbar">
          <Sidebar
            showSidebar={stateShowSidebar}
            setShowSidebar={setStateShowSidebar}
            userEntity={contextUserEntity}
            setUserEntity={setContextUserEntity}
            setShowLogin={setStateShowLogin}
            setShowChangePass={setStateShowChangePass}
            authService={new AuthService()}
            version={version}
          />
        </div>

        <div className="container" onClick={() => setStateShowSidebar(false)}>
          <div id="main">
            <div className="loading" style={{ display: stateShowLoading ? "grid" : "none" }} />
            <AnimatePresence>
              <Routes
                location={location}
                key={location.pathname}>
                <Route path="/" element={<Home loggedIn={contextUserEntity != null ? true : false} />} />
                <Route path="/master/users" element={contextUserEntity != null ? <MasterUser /> : <Home loggedIn={false} />} />
                <Route path="/master/karyawan" element={contextUserEntity != null ? <MasterKaryawan /> : <Home loggedIn={false} />} />
                <Route path="/master/vendor" element={contextUserEntity != null ? <MasterVendor /> : <Home loggedIn={false} />} />
                <Route path="/master/departemen" element={contextUserEntity != null ? <MasterDepartemen /> : <Home loggedIn={false} />} />
                <Route path="/master/lokasi" element={contextUserEntity != null ? <MasterLokasi /> : <Home loggedIn={false} />} />
                <Route path="/tapping_makanan" element={contextUserEntity != null ? <TappingMakanan /> : <Home loggedIn={false} />} />
                <Route path="/tapping_admin" element={contextUserEntity != null ? <TappingAdmin /> : <Home loggedIn={false} />} />
                <Route path="/input_qty_porsi" element={contextUserEntity != null ? <InputQtyPorsi /> : <Home loggedIn={false} />} />
                <Route path="/guest_serving" element={contextUserEntity != null ? <GuestServing /> : <Home loggedIn={false} />} />
                <Route path="/drop_off_input" element={contextUserEntity != null ? <DropOffInput /> : <Home loggedIn={false} />} />
                <Route path="/drop_off_acc" element={contextUserEntity != null ? <DropOffAccByAdmin /> : <Home loggedIn={false} />} />
                <Route path="/report/tapping_makanan" element={contextUserEntity != null ? <ReportTappingMakanan /> : <Home loggedIn={false} />} />
                <Route path="/report/drop_off" element={contextUserEntity != null ? <ReportDropOff /> : <Home loggedIn={false} />} />
                <Route path="/report/longshift" element={contextUserEntity != null ? <ReportLongshift /> : <Home loggedIn={false} />} />
                <Route path="/report/actual_porsi" element={contextUserEntity != null ? <ReportActualPorsi /> : <Home loggedIn={false} />} />
                <Route path="/report/guest_serving" element={contextUserEntity != null ? <ReportGuestServing /> : <Home loggedIn={false} />} />
                <Route path="/report/logs" element={contextUserEntity != null ? <ReportErrorLogs /> : <Home loggedIn={false} />} />
              </Routes>
            </AnimatePresence>
          </div>

          <div id="foot"></div>
        </div>

        <Login
          showLogin={stateShowLogin}
          setShowLogin={setStateShowLogin}
          setUserEntity={setContextUserEntity}
          authService={new AuthService()}
        />
        <ChangePass
          authService={new AuthService()}
          showChangePass={stateShowChangePass}
          setShowChangePass={setStateShowChangePass}
        />
        <Alert
          showAlert={stateShowAlert}
          setShowAlert={setStateShowAlert}
          alertEntity={alertEntity}
        />
      </div>
    </AppContext.Provider>
  );
}

export default App;
